/* eslint-disable react/prop-types */
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Button,
  Image,
} from "@heroui/react";
import { BsBell } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser } from "../../redux/slices/authSlice";
import axios from "axios";
const apiUrl = import.meta.env.VITE_APP_API;
const Topbar = ({ homePageData }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const accessToken = user?.token?.access;
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [hostName, setHostName] = useState("");

  const organizationData = homePageData?.organization;

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/api/post/notifiation/?page=1`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log(response.data);

        setNotifications(response.data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };
    fetchNotifications();
  }, []);

  return (
    <div className="w-screen shadow-sm fixed top-0 z-40 bg-white">
      <Navbar
        maxWidth="full"
        isMenuOpen={isMenuOpen}
        onMenuOpenChange={setIsMenuOpen}
        className="h-20 sm:container sm:mx-auto mx-auto bg-white"
      >
        {organizationData?.logo && (
          <>
            <NavbarContent className="sm:hidden pr-3" justify="center">
              <NavbarBrand>
                <a href={'/'}>
                  {/* <Image src={getLogoLink()} alt="logo" className="h-16 w-auto" /> */}
                  <Image
                    src={`${apiUrl}${organizationData?.logo}`}
                    alt="logo"
                    className="h-16 w-auto  rounded-none"
                  />
                </a>
                {/* <p className="font-bold text-inherit">ACME</p> */}
              </NavbarBrand>
            </NavbarContent>

            <NavbarContent
              className="hidden sm:flex gap-4 pr-3"
              justify="center"
            >
              <NavbarBrand>
                <a href={'/'}>
                  <Image
                    src={`${apiUrl}${organizationData?.logo}`}
                    alt="logo"
                    className="h-16 w-auto rounded-none"
                  />
                  {/* <Image src={getLogoLink()} alt="logo" className="h-16 w-auto" /> */}
                </a>
              </NavbarBrand>
            </NavbarContent>
          </>
        )}

        {/* <NavbarContent
          className="hidden sm:flex gap-14 flex-grow font-semibold"
          justify="center"
        >
          <NavbarItem>
            <Link color="foreground" href="#">
              Tution
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link href="#" aria-current="page">
              Student
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link color="foreground" href="#">
              Teacher
            </Link>
          </NavbarItem>
          <NavbarItem>
            <Link color="foreground" href="/feed">
              Feed
            </Link>
          </NavbarItem>
        </NavbarContent> */}

        <NavbarContent justify="end" style={{ flexGrow: 0 }}>
          {accessToken ? (
            <>
              <NavbarItem>
                {organizationData?.is_notification ? (
                  <div className="relative">
                    {/* Notification Button */}
                    <button
                      onClick={() => setIsOpen(!isOpen)}
                      className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 relative"
                    >
                      <BsBell className="text-xl text-black" />

                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                        {notifications.results
                          ? notifications.results.unseen
                          : 0}
                      </span>
                    </button>

                    {isOpen && (
                      <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 shadow-xl rounded-lg p-2 max-h-96 overflow-hidden">
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-2 border-b">
                          <p className="text-lg font-semibold text-gray-800">
                            Notifications
                          </p>
                          <button
                            onClick={() => setIsOpen(false)}
                            className="text-gray-500 hover:text-gray-700 transition"
                          >
                            ✖
                          </button>
                        </div>

                        {/* Notification List */}
                        <div className="max-h-80 overflow-y-auto">
                          {notifications?.results?.results?.length > 0 ? (
                            <ul className="divide-y divide-gray-200">
                              {notifications?.results.results?.map(
                                (notification, index) =>
                                  // Conditionally render the anchor tag or a div based on whether redirect_link exists
                                  notification?.redirect_link ? (
                                    <a
                                      href={
                                        notification.redirect_link.startsWith(
                                          "http"
                                        )
                                          ? notification.redirect_link
                                          : `${notification.redirect_link}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      key={index}
                                      className="block px-4 py-3 hover:bg-gray-100 transition flex items-start gap-3 w-full"
                                    >
                                      {/* Profile Icon Placeholder */}
                                      {/* <div className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0"></div> */}
                                      {/* Notification Content */}
                                      <div className="flex-1">
                                        <p className="text-gray-700 text-sm leading-tight break-words whitespace-normal">
                                          {notification?.msg || "No message"}
                                        </p>
                                        {/* <span className="text-xs text-gray-500">2h ago</span> */}
                                      </div>
                                    </a>
                                  ) : (
                                    // Render as a div if no redirect_link
                                    <div
                                      key={index}
                                      className="block px-4 py-3 hover:bg-gray-100 transition flex items-start gap-3 w-full"
                                    >
                                      {/* Profile Icon Placeholder */}
                                      {/* <div className="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0"></div> */}
                                      {/* Notification Content */}
                                      <div className="flex-1">
                                        <p className="text-gray-700 text-sm leading-tight break-words whitespace-normal">
                                           {notification?.msg || "No message"}
                                        </p>
                                        {/* <span className="text-xs text-gray-500">2h ago</span> */}
                                      </div>
                                    </div>
                                  )
                              )}
                            </ul>
                          ) : (
                            <div className="p-4 text-center text-gray-500">
                              No new notifications
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </NavbarItem>
              <NavbarItem>
                {/* <Button
                  as={Link}
                  color="warning"
                  radius="full"
                  className="font-semibold text-xl"
                  to="/chat_message"
                >
                  Messaging
                </Button> */}
              </NavbarItem>
              <NavbarItem>
                <Button
                  as={Link}
                  color="warning"
                  radius="full"
                  className="font-semibold text-xl"
                  onPress={() => window.location.replace(`/profile`)}
                >
                  Profile
                </Button>
              </NavbarItem>
              {organizationData?.is_chat ? (
                <NavbarItem>
                  <Button
                    as={Link}
                    color="warning"
                    radius="full"
                    className="font-semibold text-xl"
                    to="/chat_message"
                  >
                    Message
                  </Button>
                </NavbarItem>
              ) : (
                <></>
              )}
              <NavbarItem>
                <Button
                  color="danger"
                  radius="full"
                  className="font-semibold text-xl"
                  onClick={() => dispatch(deleteUser())}
                >
                  Logout
                </Button>
              </NavbarItem>
            </>
          ) : (
            <>
              <NavbarItem>
                <Button
                  as={Link}
                  color="primary"
                  radius="full"
                  className="font-bold text-xl w-32 h-12"
                  to="/login"
                >
                  লগ ইন
                </Button>
              </NavbarItem>
            </>
          )}
        </NavbarContent>
      </Navbar>
    </div>
  );
};

export default Topbar;
